import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { blockNavigation as blockNavigationAction, unblockNavigation as unblockNavigationAction } from 'modules/App/actions';
import { isNavigationBlocked as isNavigationBlockedSelector } from 'modules/App/selectors';
import { useAction } from './useAction';
export const useBlockNavigation = (hasChanges)=>{
    // isNavigationBlocked is used by UnsavedChangesModal
    const isNavigationBlocked = useSelector(isNavigationBlockedSelector);
    const blockNavigation = useAction(blockNavigationAction);
    const unblockNavigation = useAction(unblockNavigationAction);
    useEffect(()=>{
        if (hasChanges) {
            if (!isNavigationBlocked) blockNavigation();
        } else if (isNavigationBlocked) {
            unblockNavigation();
        }
    }, [
        hasChanges
    ]);
};
